import { BASE_API_URL, PUBLIC_API_URLS } from '../constants';
import { AppService, HTTPHeaders } from './app.service';

export const publicApiService = {
  /* ─── Apps ─── */
  get_apps: async () => {
    const headers = HTTPHeaders();
    const reqOptions = { method: 'GET' };
    const response = await AppService.makeRequest(
      BASE_API_URL + PUBLIC_API_URLS.APPS,
      { ...reqOptions, ...headers }
    );
    return response;
  },

  create_app: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = { method: 'POST' };
    const response = await AppService.makeRequest(
      BASE_API_URL + PUBLIC_API_URLS.APPS,
      { ...reqOptions, ...headers, body: JSON.stringify(data) }
    );
    return response;
  },

  delete_app: async (appId) => {
    const headers = HTTPHeaders();
    const reqOptions = { method: 'DELETE' };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${PUBLIC_API_URLS.APP_DELETE}/${appId}`,
      { ...reqOptions, ...headers }
    );
    return response;
  },

  /* ─── Client Credentials ─── */
  get_client_credentials: async (clientId) => {
    const headers = HTTPHeaders();
    const reqOptions = { method: 'GET' };
    const url = clientId
      ? `${BASE_API_URL}${PUBLIC_API_URLS.CLIENT_CREDENTIALS}?clientId=${clientId}`
      : BASE_API_URL + PUBLIC_API_URLS.CLIENT_CREDENTIALS;
    const response = await AppService.makeRequest(url, {
      ...reqOptions,
      ...headers,
    });
    return response;
  },

  generate_secret: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = { method: 'POST' };
    const response = await AppService.makeRequest(
      BASE_API_URL + PUBLIC_API_URLS.GENERATE_SECRET,
      { ...reqOptions, ...headers, body: JSON.stringify(data) }
    );
    return response;
  },

  revoke_credentials: async (clientId) => {
    const headers = HTTPHeaders();
    const reqOptions = { method: 'DELETE' };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${PUBLIC_API_URLS.REVOKE_CREDENTIALS}/${clientId}`,
      { ...reqOptions, ...headers }
    );
    return response;
  },

  /* ─── API Tokens ─── */
  get_api_tokens: async (clientId) => {
    const headers = HTTPHeaders();
    const reqOptions = { method: 'GET' };
    const url = clientId
      ? `${BASE_API_URL}${PUBLIC_API_URLS.API_TOKENS}?clientId=${clientId}`
      : BASE_API_URL + PUBLIC_API_URLS.API_TOKENS;
    const response = await AppService.makeRequest(url, {
      ...reqOptions,
      ...headers,
    });
    return response;
  },

  create_api_token: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = { method: 'POST' };
    const response = await AppService.makeRequest(
      BASE_API_URL + PUBLIC_API_URLS.API_TOKENS,
      { ...reqOptions, ...headers, body: JSON.stringify(data) }
    );
    return response;
  },

  regenerate_api_token: async (tokenId) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = { method: 'POST' };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${PUBLIC_API_URLS.REGENERATE_TOKEN}/${tokenId}/regenerate`,
      { ...reqOptions, ...headers }
    );
    return response;
  },

  revoke_api_token: async (tokenId) => {
    const headers = HTTPHeaders();
    const reqOptions = { method: 'DELETE' };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${PUBLIC_API_URLS.REVOKE_TOKEN}/${tokenId}`,
      { ...reqOptions, ...headers }
    );
    return response;
  },

  request_access: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = { method: 'POST' };
    const response = await AppService.makeRequest(
      BASE_API_URL + PUBLIC_API_URLS.REQUEST_ACCESS,
      { ...reqOptions, ...headers, body: JSON.stringify(data) }
    );
    return response;
  },
};
